import React from "react";
import { EmojiPanel } from "../comp/EmojiPanel";
import { Icon } from "../comp/Icon";

export class LeftPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tooltip: "---",
            firstRandomise: false
        };

        this.options = [
            {
                name: "Apple",
                code: "apple"
            },
            {
                name: "Twitter",
                code: "twitter"
            },
            {
                name: "Ugly emojis",
                code: "ugly"
            }
        ];

        this.tooltipChange = this.tooltipChange.bind(this);
        this.randomise = this.randomise.bind(this);
    }
    

    tooltipChange(text) {
        // change tooltip text
        if(text == "") {
            // if blank
            this.setState({ tooltip: "---" });
        }
        else {
            this.setState({ tooltip: ":" + text + ":" });
        }
    }

    
    random(list) {
        // gets a random entry from the provided list
        return list[Math.floor((Math.random()*list.length))];
    }

    randomise() {
        // randomise face, 2 eyes, mouth, accessory
        this.props.clear();

        this.props.add( "heads", this.random(this.props.emoji.heads) );
        this.props.add( "eyes", this.random(this.props.emoji.eyes) );
        this.props.add( "eyes", this.random(this.props.emoji.eyes) );
        this.props.add( "mouths", this.random(this.props.emoji.mouths) );
        this.props.add( "accessories", this.random(this.props.emoji.accessories) );
    }


    render() {

        return (
            <div className="panel emoji-picker">
                <h1>Pick your parts</h1>

                <div className="buttons main give-tooltip" data-tooltip="Randomise">
                    <button onClick={this.randomise}> <Icon type="fa-random" /> </button>
                </div>

                <label onDoubleClick={this.props.changeCollection}>
                    Emoji set:{" "}
                    <select name="collection" onChange={this.props.changeCollection} value={this.props.collection}>

                        {
                            this.options.map((item, i) => {
                                return <option key={i} value={item.code}>{item.name}</option>
                            })
                        }
                        <option value="" disabled>---</option>
                        <option value="custom">Custom</option>
                    </select>
                </label>


                {
                    this.props.emoji.map((item, i) => {
                        return (
                            <EmojiPanel 
                                key={i}
                                title={item.title} 
                                section={item.code} 
                                items={item.data} 
                                tip={this.tooltipChange}
                                add={this.props.add} 
                                collection={this.props.collection}
                            />
                        );
                    })
                }

                {
                    (this.props.emoji.length == 0) ? 
                        <div className="error">
                            Collection is empty
                        </div>
                     : ""
                }


                <div className="tooltip">
                    {this.state.tooltip}
                </div>
            </div>
        );
    }
}


LeftPanel.defaultProps = {
    emoji: []
};
